module.exports = __webpack_public_path__ + "img/ayla.9c563d3c.png";